/*
 * The sketch rail sits BELOW the media, inside the block — not floating over it.
 *
 * The overlay badge it replaces obscured the artwork, had nowhere to put actions, and on a
 * touch device could not be reached at all. Nothing here filters, desaturates or dims the media
 * itself: a musician judging a mood sketch or auditioning a demo track needs to see and hear it
 * truly, and degrading the artefact to signal its status corrupts the only thing it is for.
 */
.rail {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-1, 4px);
  padding: 2px var(--tuna-spacing-1, 4px);
  border-top: 1px dashed var(--tuna-palette-divider);
  color: var(--tuna-palette-text-secondary);
  font-size: var(--tuna-typography-fontSize-xs);
  line-height: 1.4;
  user-select: none;
}

.label {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-1, 4px);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/*
 * Quiet but always present. Invisible-until-hovered would strand every touch user, so the
 * actions merely recede at rest and come forward on hover or keyboard focus.
 */
.actions {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-1, 4px);
  flex-shrink: 0;
  opacity: 0.6;
}

.rail:hover .actions,
.rail:focus-within .actions {
  opacity: 1;
}

@media (prefers-reduced-motion: no-preference) {
  .actions {
    transition: opacity 120ms ease-in-out;
  }
}

/* No hover to reveal anything on a touch device, and a 44px target per WCAG 2.2. */
@media (pointer: coarse) {
  .actions {
    opacity: 1;
  }

  .rail {
    min-height: 48px;
  }

  .action {
    min-width: 44px;
    min-height: 44px;
  }
}
